// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM15.5408 9.90565L17.3618 8.88133L16.3813 7.13818L13 9.04019L13 10.5L16.2 12.9L17.4 11.3L15.5408 9.90565ZM9 12V8.00002H7V12H9ZM12 19C14.7614 19 17 16.7614 17 14H7C7 16.7614 9.23858 19 12 19Z"}}]};

const GiggleFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'giggle-filled',
    ref,
    icon: element,
  },
));

GiggleFilledIcon.displayName = 'GiggleFilledIcon';

export default GiggleFilledIcon;
